export const getArticleId = () => {
    var _a;
    const currentContext = (_a = window.SilverSurferSDK.getContext()) === null || _a === void 0 ? void 0 : _a.current;
    const wikiId = currentContext === null || currentContext === void 0 ? void 0 : currentContext.productId;
    const pageId = currentContext === null || currentContext === void 0 ? void 0 : currentContext.pageId;
    if (!wikiId || !pageId) {
        return null;
    }
    const articleId = `${wikiId}-${pageId}`;
    return {
        wikiId,
        articleId,
        pageId,
    };
};
